export default Object.freeze({
  BASIC_IMFORMATION: '기본정보',
  MALL: '쇼핑몰',
  GROUP_TYPE: '상품군',
  GROUP_TYPE_DELIVERY: '배송상품군',
  GROUP_TYPE_SERVICE: '서비스상품군',
  CLASS_TYPE: '상품유형',
  CLASS_TYPE_DEFAULT: '일반상품',
  CLASS_TYPE_OFFLINE: '오프라인상품',
  CLASS_TYPE_RENTAL: '렌탈상품',
  PRODUCT_MANUFACTURE_NAME: '제조사명',
  PRODUCT_MODEL_NAME: '제품모델명',
  PRODUCT_SERIAL_NUMBER: '제품일련번호',
  PARTNER: '파트너사',
  SALE_METHOD_TYPE: '판매방식',
  SALE_METHOD_TYPE_PURCHASE: '사입',
  SALE_METHOD_TYPE_CONSIGNMENT: '위탁',
  ADMIN: '담당자',
  CATEGORY: '표준카테고리',
  DISPLAY_CATEGORY: '전시카테고리',
  PLATFORM_DISPLAYINFO: '플랫폼별 노출설정',
  PLATFORM_DISPLAYINFO_MOBILEWEB: '모바일 웹',
  PLATFORM_DISPLAYINFO_MOBILE: '모바일 앱',
  MEMBER_GRADE_DISPLAYINFO: '회원등급 노출 설정',
  MEMBER_GROUP_DISPLAYINFO: '회원그룹 노출 설정',
  PRODUCT_NAME: '상품명',
  PRODUCT_NAME_EN: '영문상품명',
  PROMOTION_TEXT: '홍보문구',
  BRAND: '브랜드',
  MINOR_PURCHASE_YN: '미성년자구매',
  PAYMENT_MEANS: '결제수단제어',
  PAYMENT_MEANS_PAYCO: '페이코',
  PAYMENT_MEANS_RENTAL: '렌탈결제',
  PAYMENT_MEANS_CREDIT: '신용카드',
  PAYMENT_MEANS_REALTIME_TRANSFER: '실시간계좌이체',
  PAYMENT_MEANS_DEPOSIT: '가상계좌',
  PAYMENT_MEANS_ESCROW_REALTIME_TRANSFER: '실시간계좌이체-에스크로',
  PAYMENT_MEANS_ESCROW_VIRTUAL_ACCOUNT: '가상계좌-에스크로',
  CART: '장바구니',
  KEYWORDS: '검색어',
  SALE_INFO: '판매정보',
  RESERVATION_INFO: '예약판매',
  SALE_PERIOD_INFO: '판매기간',
  SALE_PERIOD_INFO_REGULAR: '상시 판매',
  SALE_PERIOD_INFO_ELSE: '기간지정 판매',
  COMMISSION_INFO: '판매수수료',
  COMMISSION_INFO_PRODUCT: '상품수수료',
  COMMISSION_INFO_CATEGORY: '카테고리수수료',
  COMMISSION_INFO_PARTNER: '파트너수수료',
  COMMISSION_INFO_PURCHASE_PRICE: '공급가입력',
  SALE_PRICE: '판매가',
  APPLIED_ADDITIONAL_DISCOUNT_PRICE: '추가할인적용가',
  IMMEDIATE_DISCOUNT_INFO: '즉시할인',
  PURCHASE_PRICE: '매입가',
  SUPPLY_PRICE: '공급가',
  PARTNER_CHARGE_AMT: '파트너사분담금',
  ACCUMULATION_RATE: '개별 적립금 설정',
  ACCUMULATION_USEYN: '적립금사용',
  PROMOTION_INFO: '프로모션',
  PRODUCT_STOCK_CNT: '재고수량(판매가능재고)',
  PRODUCT_RESTOCK: '재입고 알림 사용 설정',
  PRODUCT_STOCK_CNT1: '재고수량',
  PRODUCT_STOCK_CNT2: '(판매가능재고)',
  MIN_BUY_CNT: '최소구매수량',
  MAX_BUY_COUNT_INFO: '최대구매수량',
  MAX_BUY_COUNT_INFO_PERSON: '1인당 최대 구매 수량',
  MAX_BUY_COUNT_INFO_TIME: '1회당 최대 구매 수량',
  MAX_BUY_COUNT_INFO_DAY: '최대구매수량 기간 제한 - 제한 수량',
  MAX_BUY_COUNT_INFO_CNT: '일동안 최대',
  MAX_BUY_COUNT_INFO_CNT2: '개 구매가능',
  OPTIONS: '옵션',
  MALL_ADDITION_PRODUCT: '추가상품',
  COMPARING_PRICE_SITE_INFO: '가격비교사이트 등록',
  COMPARING_PRICE_SITE_INFO_DAUM: '다음쇼핑하우',
  COMPARING_PRICE_SITE_INFO_NAVER: '네이버쇼핑',
  COMPARING_PRICE_SITE_INFO_FACEBOOK: '페이스북 카탈로그',
  COMPARING_PRICE_SITE_INFO_ENURI: '에누리',
  COMPARING_PRICE_SITE_INFO_DANAWA: '다나와',
  COMPARING_PRICE_SITE_INFO_COOCHA: '쿠차',
  COMPARING_PRICE_SITE_INFO_WONDER: '위메프원더쇼핑',
  COMPARING_PRICE_SITE_INFO_PAYCO: '페이코쇼핑',
  PLACE_ORIGIN_INFO: '원산지',
  DUTY_CONTENT: '상품정보고시',
  DUTY_CONTENT2: '상품고시',
  CERTIFICATION_INFO: '인증정보',
  CERTIFICATION_INFO_TARGET: '인증대상',
  CERTIFICATION_INFO_NOT_TARGET: '인증대상아님',
  CERTIFICATION_INFO_DETAIL_PAGE: '상세페이지 별도표기',
  MANUFACTURE_YMDT: '제조일자',
  EXPIRATION_YMDT: '유효일자',
  VALUE_ADDED_TAX_TYPE: '부가세',
  VALUE_ADDED_TAX_TYPE_DUTY: '과세',
  VALUE_ADDED_TAX_TYPE_DUTYFREE: '면세',
  VALUE_ADDED_TAX_TYPE_SMALL: '영세',
  PRODUCT_MANAGEMENT_CD: '상품관리코드',
  REFUNDABLE_YN: '주문환불',
  STICKERS: '스티커',
  ICON: '아이콘',
  IMAGE_INFO: '이미지정보',
  MAIN_IMAGE: '대표이미지',
  LIST_IMAGE: '리스트 이미지',
  LIQUOR_DUTY_1: '주류 통신판매',
  LIQUOR_DUTY_2: '명령위임고시',
  CONTENT_HEADER: '상품 상세(상단)',
  CONTENT_FOOTER: '상품 상세(하단)',
  CONTENT: '상품 상세',
  UPDATE: '수정필요',
  DELIVERY_YN: '배송여부',
  DELIVERY_Y: '배송',
  DELIVERY_N: '배송안함',
  DELIVERY_INFO: '배송정보',
  SHIPPING_AREA_TYPE: '배송구분',
  SHIPPING_AREA_TYPE_PARTNER: '파트너사 배송',
  SHIPPING_AREA_TYPE_MALL: '쇼핑몰 배송',
  DELIVERY_COMBINATION_YN: '묶음배송 가능여부',
  DELIVERY_INTERNATIONAL_YN: '해외배송 여부',
  DELIVERY_TEMPLATE: '배송 템플릿 목록',
  DELIVERY_TYPE: '배송방법/택배사',
  DELIVERY_CONDITION_TYPE: '배송비유형',
  RELEASE_WAREHOUSE: '출고지주소',
  RETURN_WAREHOUSE: '반품교환지 주소',
  RETURN_DELIVERY_AMT: '반품/교환 배송비',
  DELIVERY_CUSTOMER_INFO: '판매자 특이사항/고객안내사항',
  ETC_INFO: '별도 승인거부 의견',
  ADD: '지급',
  COUPON: '쿠폰',
  ADDITIONALDISCOUNT: '추가할인',
  REFUND_Y: '환불가능',
  REFUND_N: '환불불가',
  CANCEL_N: '취소불가',
  EXCHANGE_N: '교환불가',
  RETURN_N: '반품불가',
  NO: '등록안함',
  YES: '등록',
  ALL: '등록(전체)',
  USE_REGISTERED_OPTIONAL_IMAGES: '등록된 옵션이미지 사용',
  CAN_DELIVERY_COMBINATION: '묶음배송 가능',
  UNABLE_DELIVERY_COMBINATION: '묶음배송 불가능(상품별 배송비 적용)',
  DELIVERY_INTERNATIONAL_Y: '해외배송상품 (해외 -> 대한민국으로 배송되는 상품)',
  DELIVERY_INTERNATIONAL_N: '국내배송상품',
  SALE_APPROVE: '판매승인',
  APPROVE_REJECT: '승인거부',
  DISPLAY: '노출',
  NOT_SET: '설정 안함',
  ALL_SET: '전체 설정',
  DUE: '설정기간',
  ALL_CAN: '전체가능',
  DUE_SET: '기간설정',
  DUE_LIMIT: '기간제한',
  FIXED_FEE: '배송비',
  ORDER_AMT: '주문금액',
  CONDITION: '원 이상 배송비 무료 미만 시',
  DELIVERY_DUE_DATE: '배송지정일',
  SELECTED: '개별상품',
  CUSTOM_ORDER: '수동진열',
  LATEST_REGISTER_DATE: '최신 등록순',
  SALES_COUNT: '판매량순',
  BY_VTR: '조회순',
  REVIEW_COUNT: '상품평순',

  TARGET_LOCATION: '번 위치로',
  MOVE: '이동',
  FIX: '상단고정',
  NEED_TARGET: '이동 순서를 입력해주세요.',
});
